import { __assign } from 'tslib';
import copy from 'utils-copy-error';

var SlardarLogger =
/** @class */
function () {
  function SlardarLogger(client, commonExtra) {
    var _this = this; // 将传入的tags与commonTags合并并格式化一些数据


    this._parseExtra = function (extra) {
      var tempExtra = __assign(__assign({}, _this.commonExtra), extra);

      var resExtra = {};

      try {
        for (var key in tempExtra) {
          if (Object.prototype.hasOwnProperty.call(tempExtra, key)) {
            resExtra[key] = typeof tempExtra[key] === 'string' || typeof tempExtra[key] === 'number' ? tempExtra[key] : JSON.stringify(tempExtra[key]);
          }
        }
      } catch (error) {}

      return resExtra;
    };

    this._capture = function (level, error, message, extra) {
      var _a;

      if (message === void 0) {
        message = '';
      }

      try {
        var _error = copy(error);

        extra = _this._parseExtra(extra);
        _error.message = level + " | " + (_error === null || _error === void 0 ? void 0 : _error.message) + " | " + message;
        (_a = _this.client) === null || _a === void 0 ? void 0 : _a.call(_this, 'captureException', _error, extra);
      } catch (e) {}
    };

    this.client = client;
    this.commonExtra = commonExtra;
  }
  /**
   * 需要立即报警的错误
   * @param error `Error`错误对象
   * @param message 额外描述
   * @param extra 额外上报信息
   */


  SlardarLogger.prototype.fatal = function (error, message, extra) {
    this._capture('__Fatal__', error, message, extra);
  };
  /**
   * 普通错误
   * @param error `Error`错误对象
   * @param message 额外描述
   * @param extra 额外上报信息
   */


  SlardarLogger.prototype.error = function (error, message, extra) {
    this._capture('__CustomError__', error, message, extra);
  };
  /**
   * Debug
   * @param content 日志内容，以`${PID}_`开头;
   * @param extra 额外上报信息
   */


  SlardarLogger.prototype.debug = function (content, extra) {
    var _a;

    extra = this._parseExtra(extra);
    (_a = this.client) === null || _a === void 0 ? void 0 : _a.call(this, 'sendLog', {
      level: 'debug',
      content: content,
      extra: extra
    });
  };
  /**
   * 自定义事件
   * @param name 事件名，以`${PID}_`开头;
   * @param extra 额外上报信息 number会同时以`metrics`上报
   *
   */


  SlardarLogger.prototype.info = function (name, extra) {
    var _a;

    var categories = this._parseExtra(extra);

    var metrics = {};

    for (var key in categories) {
      if (Object.prototype.hasOwnProperty.call(categories, key)) {
        if (typeof categories[key] === 'number') {
          metrics[key] = categories[key];
        }
      }
    }

    (_a = this.client) === null || _a === void 0 ? void 0 : _a.call(this, 'sendEvent', {
      type: 'event',
      name: name,
      metrics: metrics,
      categories: categories
    });
  };

  return SlardarLogger;
}();

var SlardarLogger$1 = SlardarLogger;

var LynxLogger =
/** @class */
function () {
  function LynxLogger(client, commonExtra) {
    var _this = this; // 将传入的tags与commonTags合并并格式化一些数据


    this._parseExtra = function (extra) {
      var tempExtra = __assign(__assign({}, _this.commonExtra), extra);

      var resExtra = {};

      try {
        // eslint-disable-next-line no-restricted-syntax
        for (var key in tempExtra) {
          if (Object.prototype.hasOwnProperty.call(tempExtra, key)) {
            resExtra[key] = typeof tempExtra[key] === 'string' || typeof tempExtra[key] === 'number' ? tempExtra[key] : JSON.stringify(tempExtra[key]);
          }
        }
      } catch (error) {}

      return resExtra;
    };

    this._capture = function (level, error, message, extra) {
      var _a;

      if (message === void 0) {
        message = '';
      }

      try {
        extra = _this._parseExtra(extra);
        var errorMessage = level + " | " + (error === null || error === void 0 ? void 0 : error.message) + " | " + message;
        (_a = _this.client) === null || _a === void 0 ? void 0 : _a.reportJSError({
          data: {
            error_message: errorMessage,
            fileName: error === null || error === void 0 ? void 0 : error.fileName,
            lineNumber: error === null || error === void 0 ? void 0 : error.lineNumber,
            columnNumber: error === null || error === void 0 ? void 0 : error.columnNumber,
            stack: error === null || error === void 0 ? void 0 : error.stack
          },
          context: extra
        }, function () {});
      } catch (e) {}
    };

    this.client = client;
    this.commonExtra = commonExtra;
  }
  /**
   * 需要立即报警的错误
   * @param error `Error`错误对象
   * @param message 额外描述
   * @param extra 额外上报信息
   */


  LynxLogger.prototype.fatal = function (error, message, extra) {
    this._capture('__Fatal__', error, message, extra);
  };
  /**
   * 普通错误
   * @param error `Error`错误对象
   * @param message 额外描述
   * @param extra 额外上报信息
   */


  LynxLogger.prototype.error = function (error, message, extra) {
    this._capture('__CustomError__', error, message, extra);
  };
  /**
   * 自定义事件
   * @param name 事件名，注意避免命名冲突
   * @param extra 额外上报信息 number会同时以`metrics`上报
   *
   */


  LynxLogger.prototype.info = function (name, extra) {
    var _a; // 将extra中的number字段上报到metrics中


    var categories = this._parseExtra(extra);

    var metrics = {}; // eslint-disable-next-line no-restricted-syntax

    for (var key in categories) {
      if (Object.prototype.hasOwnProperty.call(categories, key)) {
        if (typeof categories[key] === 'number') {
          metrics[key] = categories[key];
        }
      }
    }

    (_a = this.client) === null || _a === void 0 ? void 0 : _a.customReport({
      eventName: name,
      metrics: metrics,
      category: categories,
      extra: categories
    }, function () {});
  };
  /**
   * 更新上报信息
   * @param extra 上报信息
   *
   */


  LynxLogger.prototype.updateCommonExtra = function (extra) {
    this.commonExtra = __assign(__assign({}, this.commonExtra), extra);
  };

  return LynxLogger;
}();

var LynxLogger$1 = LynxLogger;

export { LynxLogger$1 as LynxLogger, SlardarLogger$1 as SlardarLogger };
//# sourceMappingURL=index.es.js.map
